import { useState } from "react";
import { Link } from "react-router-dom";
import { useCalendarStore, useSelectFormStore, useForm } from "../../hooks";
import { SecretaryLayout } from "../Layout";
import { ProcedureCalendar } from "../components";
import { SelectForm, LoadingData, ErrorMessage } from "../ui";
import { useFormMessages } from "../hooks";

const formData = {
  headquarterId: "",
  surgeryRoomId: "",
};

const formValidations = {
  headquarterId: [(value) => value.length > 0, "Selecciona una sede"],
  surgeryRoomId: [
    (value) => value.length > 0,
    "Selecciona una sala de cirugía",
  ],
};

export const ProcedureCalendarPage = () => {
  // Datos de hooks ----------------------------------------//
  const {
    //Props
    isLoadingData,
    isLoading,
    calendar,
    message,

    //Methods
    startGetSurgeryRoomsByHeadquarterId,
    startGetScheduleBySurgeryRoomId,
  } = useCalendarStore();

  const { isLoading: isLoadingForm, headquarters } = useSelectFormStore([
    "headquarters",
  ]);

  // States ------------------------------------------------//
  const [validateForm, setValidateForm] = useState(false);
  const [surgeryRooms, setSurgeryRooms] = useState([]);

  // Formulario --------------------------------------------//
  const { formState, formValidation, onInputChange, isFormValid } = useForm(
    formData,
    formValidations
  );

  const { formSubmitted, setFormSubmitted, showErrorMessage, messageText } =
    useFormMessages({
      message,
      setValidateForm,
    });

  const { headquarterId, surgeryRoomId } = formState;

  const { headquarterIdValid, surgeryRoomIdValid } = formValidation;

  // Funciones ---------------------------------------------//
  const headquarterChange = async (event) => {
    onInputChange(event);
    const surgeryRooms = await startGetSurgeryRoomsByHeadquarterId(
      event.target.value
    );
    if (surgeryRooms && surgeryRooms.length > 0) {
      return setSurgeryRooms(surgeryRooms);
    }
    return setSurgeryRooms([]);
  };

  const onSubmit = (event) => {
    event.preventDefault();
    setFormSubmitted(true);
    if (isFormValid) {
      startGetScheduleBySurgeryRoomId(formState);
    }
  };

  // Efectos -----------------------------------------------//

  return (
    <SecretaryLayout>
      <div className="container-fluid">
        <div className="layout-specing">
          <div className="row mb-4">
            <div className="col-xl-9 col-md-6">
              <h5 className="mb-0">Calendario procedimiento</h5>

              <nav aria-label="breadcrumb" className="d-inline-block mt-2">
                <ul className="breadcrumb breadcrumb-muted bg-transparent rounded mb-0 p-0">
                  <li className="breadcrumb-item">
                    <Link to="/secretary/dashboard">gosafe</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Calendario procedimiento
                  </li>
                </ul>
              </nav>
            </div>
          </div>

          <div className="card border-0 p-4 rounded shadow mb-4">
            <form onSubmit={onSubmit}>
              <div className="row align-items-end g-3">
                {/* Formulario estatico */}
                <>
                  <div className="col-md-4">
                    <SelectForm
                      label={"Sede - ips"}
                      options={headquarters}
                      labelKey={"name"}
                      validation={headquarterIdValid}
                      submit={validateForm}
                      name={"headquarterId"}
                      value={headquarterId}
                      onInputChange={headquarterChange}
                    />
                  </div>
                  {surgeryRooms.length > 0 && (
                    <>
                      <div className="col-md-4">
                        <SelectForm
                          label={"Sala de procedimiento"}
                          options={surgeryRooms}
                          labelKey={"name"}
                          validation={surgeryRoomIdValid}
                          submit={validateForm}
                          name={"surgeryRoomId"}
                          value={surgeryRoomId}
                          onInputChange={onInputChange}
                        />
                      </div>
                      <div className="col-md-4">
                        <button
                          type="submit"
                          className="btn btn-primary w-100"
                          disabled={isLoading || isLoadingForm || isLoadingData}
                        >
                          Buscar
                        </button>
                      </div>
                    </>
                  )}
                </>

                {/* Mensajes */}
                <>
                  {(isLoading || isLoadingForm || isLoadingData) && (
                    <div className="col-md-12">
                      <LoadingData />
                    </div>
                  )}
                  {showErrorMessage ||
                    (headquarterId && message?.type === "errorSelect" && (
                      <div className="col-md-12">
                        <ErrorMessage>
                          {messageText || message?.text}
                        </ErrorMessage>
                      </div>
                    ))}
                </>
              </div>
            </form>
          </div>

          {calendar && formSubmitted && <ProcedureCalendar />}
        </div>
      </div>
    </SecretaryLayout>
  );
};
